import Vue from 'vue';

Vue.component('customer-engagement-index', () =>
    import(/* webpackChunkName: 'customer-engagement-index.vue' */ './customer-engagement-index.vue'),
);

Vue.component('gamification-index', () =>
    import(/* webpackChunkName: 'gamification-index.vue' */ './gamification/gamification-index.vue'),
);

Vue.component('upsell-index', () =>
    import(/* webpackChunkName: 'upsell-index.vue' */ './upsell/upsell-index.vue'),
);
